import React, { useState, useEffect, useCallback } from "react";
import {
  DownOutlined,
  RightOutlined,
  UpOutlined,
  FileExcelFilled,
  FileWordOutlined,
  FileZipOutlined,
  FileImageFilled,
  FilePdfFilled,
} from "@ant-design/icons";
import styled from "styled-components";
import { ReactComponent as Imag1 } from "../../assets/img.svg";
import { ReactComponent as PDFimge } from "../../assets/pdf.svg";
import { ReactComponent as Trash } from "../../assets/Trash_Full.svg";
import { ReactComponent as Edit } from "../../assets/Edit_Pencil_01.svg";
import { ReactComponent as Send } from "../../assets/send.svg";
import { ReactComponent as FaceIcon } from "../../assets/face.svg";
import { ReactComponent as Tick } from "../../assets/tick.svg";
import {
  Button,
  Input,
  message,
  Modal,
  Form,
  Select,
  Spin,
  Upload,
  Avatar,
} from "antd";
import { useHistory, useLocation } from "react-router-dom";
import {
  getClientid,
  getUserInfo,
  getUserList,
  getMenuList,
  getUserRoleId,
  getLocations,
  getTimeZone,
  getCountryTimezoneList
} from "redux/selectors";
import moment from "moment-timezone";
import { getValidTimezone } from "utils/Date";
import { connect } from "react-redux";
import { CALL_API } from "common/API";
import ReportIncident from "./ReportIncident";
import { get, startCase } from "lodash";
import COLORS from "common/Colors";

const props = {
  name: "file",
  action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
  headers: {
    authorization: "authorization-text",
  },
  onChange(info) {
    if (info.file.status !== "uploading") {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === "done") {
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
};
const StyledAvatar = styled(Avatar)`
  margin-top: 5px;
  // margin-right: 0.5rem;
  line-height: 40px;
  width: 40px;
  height: 40px;
  background-color: ${COLORS.PRIMARY};
  vertical-align: middle;
  color: #000;
`;
const Styleddiv = styled.div`
  .breadcrumb {
    display: flex;
    align-items: center;
  }
  .disciplinary-text {
    cursor: pointer;
    font-weight: 400;
    font-size: 16px;
    color: #636980;
  }
  .breadcrumb svg {
    width: 10px;
    height: 10px;
    color: #636980;
    margin-bottom: 10px;
  }
  .view-detail {
    font-weight: 400;
    font-size: 16px;
  }
  .emp-name {
    font-weight: 500;
    font-size: 16px;
    color: #1f243b;
  }
  .emp-id {
    font-weight: 400;
    font-size: 14px;
    color: #636980;
    margin-bottom: 13px;
  }
  .name-edit-delete {
    display: flex;
    justify-content: space-between;
  }
  .name-edit-delete div {
    display: flex;
    align-items: center;
  }
  .trash-edit-move {
    margin-right: 70px;
    gap: 10px;
  }
  .two-container {
    display: flex;
    gap: 20px;
  }
  .employee-div {
    display: flex;
    flex-wrap: wrap;
  }
  .line-emp-id {
    color: #e2e2e8;
    margin-bottom: 15px;
  }
  .emp-name-id {
    gap: 10px;
  }
  .id-upload {
    display: flex;
    justify-content: space-between;
    // gap: 50px;
  }
  .employee-title {
    width: 30%;
    font-weight: 500;
    font-size: 14px;
    color: #636980;
    text-align: left;
  }
  .employee-total {
    width: 639px;
    // height: 412px;
    border-radius: 8px;
    border: 1px solid #e2e2e8;
    padding: 10px;
  }
  .timeline-total {
    width: 639px;
    // height: 412px;
    border-radius: 8px;
    border: 1px solid #e2e2e8;
    padding: 10px;
  }
  .employee-id {
    font-weight: 500;
    font-size: 16px;
  }
  .attach-text {
    color: #2d53da;
    border: none;
  }
  .item-value {
    font-weight: 400;
    font-size: 16px;
    color: #1f243b;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: space-between;
  }
  .add-comments {
    font-weight: 500;
    font-size: 16px;
    color: #1f243b;
  }
  .custom-select .ant-select-selector {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    // border: none;
    border: 1px solid #2d53da;
  }
  .custom-select .ant-select-placeholder {
    color: #2d53da;
  }
  .comments-input {
    border-radius: 34pc;
  }
  .actions-timeline {
    font-weight: 500;
    font-size: 16px;
  }
  .timeline-name {
    font-weight: 400;
    font-size: 16px;
  }
  .timeline-action {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
  }
  .verbal-warning,
  .first-warning,
  .second-warning {
    color: #119de5;
  }
  .third-final-warning,
  .show-cause {
    color: #f28916;
  }
  .timeline-date-time {
    font-weight: 400;
    font-size: 14px;
    color: #636980;
  }
  .timeline-date-time1 {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
  }
  .scrollable-container {
    max-height: 412px;
    overflow-y: auto;
  }
  // .timeline-item {
  //   word-wrap: break-word;
  // }
  .face-content {
    display: flex;
    gap: 10px;
  }
  .face-content1 {
    display: flex;
    gap: 10px;
    padding-bottom: 10px;
  }
  .for-commented {
    text-decoration: underline;
    color: #2d53da;
    cursor: pointer;
    margin-left: 130px;
    white-space: nowrap;

  }

  .comment-para {
    margin-top: -15px;
    // margin-left:-45px;
    font-weight: 400;
    font-size: 14px;
    color: #636980;
  }
  .resolved {
    color: #22ad22;
  }

  .dismissed {
    color: #d90325;
  }

  .under-review {
    color: #f28916;
  }
`;
const StyledModal = styled(Modal)`
  .ant-modal-mask {
    background-color: rgba(0, 0, 0, 0.01) !important;
  }
  .delete-modal-text {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
  }
  .yes-no-button {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
  .no-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #2d53da;
    color: #2d53da;
  }
  .yes-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    background-color: #2d53da;
    color: #ffffff;
  }
  .success-modal {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .sent-successfully {
    font-size: 16px;
    font-weight: 400;
  }
`;
function ViewIncident({
  onBack,
  userInfo,
  ClientId,
  userList,
  menuList,
  userRoleId,
  locationList,
  timeZone,
  CountryTimezone
}) {
  const [details, setDetails] = useState({});
  const history = useHistory();
  const location = useLocation(); // Get location state
  const incidentData = location.state?.incidentData;
  const page = location.state?.page;
  const [isLoading, setIsLoading] = useState(false); // Add a loading state

  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isDeletedModalOpen, setIsDeletedModalOpen] = useState(false);
  const [isCommentVisible, setIsCommentVisible] = useState("");
  const handleCommentVisibility = (index) => {
    setIsCommentVisible(index);
  };
  const handleBack = () => {
    history.push("/MyIncident"); // Navigate to the "/myincident" route
  };
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedIncidentId, setSelectedIncidentId] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState({});
  const [incidentToDelete, setIncidentToDelete] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const Menulist = menuList[userRoleId] || Object.values(menuList)[0]; // Added Menulist logic

  const handleEditDisciplinary = (record) => {
    setSelectedIncidentId(record.incidentId);
    setSelectedRecord(record);

    setIsModalOpen(true);
  };
  const closeReportModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);
  useEffect(() => { }, [selectedRecord]);
  const handleDeleteOpen = (id) => {
    setIncidentToDelete(id);
    setIsDeleteOpen(true);
  };
  const handleDeleteCancel = () => {
    setIsDeleteOpen(false);
  };
  const handleDeleteConfirm = async () => {
    if (!incidentToDelete) {
      message.error("Invalid incident ID.");
      return;
    }

    const response = await CALL_API(
      `incident/${ClientId}/${incidentToDelete}`,
      "delete"
    );

    if (response.code === "SUCCESS") {
      setIsDeleteOpen(false);
      setIsDeletedModalOpen(true);
      setTimeout(() => {
        setIsDeletedModalOpen(false);
        history.push("/myincident");
      }, 1000);

      return true;
    } else {
      message.error("Failed to delete incident. Please try again.");
      return false;
    }
  };
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const handleOpenModal = () => setIsModalOpen1(true);
  const handleCloseModal = () => {
    setIsModalOpen1(false);
    setFileUrl(null);
  };

  const managingOffice = "Kenya"; // hardcoded based on dashboard time

  const userTimeZone = getValidTimezone(
    CountryTimezone?.find((tz) => tz.country === managingOffice)?.Timezone
  );

  const imageUrl =
    Array.isArray(incidentData?.evidence) && incidentData.evidence.length > 0
      ? incidentData.evidence[0]?.fileName // Get first file's URL
      : "";

  let imageName = "---";

  if (imageUrl && typeof imageUrl === "string" && imageUrl.trim() !== "") {
    const fileName = imageUrl.split("/").pop(); // Extract the last part of the URL
    const nameParts = fileName.split("-"); // Split by "-"
    imageName = nameParts.length > 1 ? nameParts.slice(1).join("-") : fileName; // Remove first part (incidentId)
  }

  const EmployeeId = [
    {
      title: "Incident Type",
      value: incidentData?.type,
      key: 1,
    },
    {
      title: "Date",
      value: moment(incidentData?.date, "YYYY-MM-DD").format("Do MMMM YYYY"),
      key: 2,
    },
    {
      title: "Time",
      value: moment(incidentData?.time, "HH:mm:ss").format("hh:mm A"),
      key: 3,
    },
    {
      title: "Location",
      value: incidentData?.incidentlocation
        ? incidentData.incidentlocation.charAt(0).toUpperCase() +
        incidentData.incidentlocation.slice(1).toLowerCase()
        : "",
      key: 4,
    },
    {
      title: "Description",
      value: incidentData?.description,
      key: 5,
    },
    {
      title: "Attachment",
      value:
        incidentData?.evidence?.length > 0
          ? incidentData?.evidence.map((file, index) => {
            const fileName = file.fileName;
            const fileExtension = fileName.split(".").pop()?.toLowerCase();

            // Determine file type label
            let fileLabel = null;
            if (
              ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(
                fileExtension
              )
            ) {
              fileLabel = <FileImageFilled style={{ fontSize: 18, color: "#1890ff" }} />;
            } else if (fileExtension === "pdf") {
              fileLabel = <FilePdfFilled style={{ fontSize: 18, color: "#d32029" }} />;
            } else if (["xlsx", "xls", "csv"].includes(fileExtension)) {
              fileLabel = (
                <FileExcelFilled
                  style={{ color: "green", fontSize: "20px" }}
                />
              );
            } else if (["doc", "docx"].includes(fileExtension)) {
              fileLabel = (
                <FileWordOutlined style={{ color: "blue", fontSize: "20px" }} />
              );
            } else if (["zip", "rar", "7z"].includes(fileExtension)) {
              fileLabel = (
                <FileZipOutlined style={{ color: "gray", fontSize: "20px" }} />
              );
            }

            return (
              <span
                key={index}
                onClick={() => {
                  if (fileExtension === "csv") {
                    const link = document.createElement("a");
                    link.href = file.fileUrl;
                    link.download = file.fileName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  } else if (["doc", "docx"].includes(fileExtension)) {
                    const link = document.createElement("a");
                    link.href = file.fileUrl;
                    link.download = file.fileName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  } else if (["zip", "rar", "7z"].includes(fileExtension)) {
                    const link = document.createElement("a");
                    link.href = file.fileUrl;
                    link.download = file.fileName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  } else if (["xlsx", "xls"].includes(fileExtension)) {
                    window.open(file.fileUrl, "_blank");
                  } else {
                    setFileUrl(file.fileUrl);
                    handleOpenModal();
                  }
                }}
                style={{
                  boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.2)",
                  padding: "5px 8px",
                  border: "none",
                  borderRadius: "5px",
                  backgroundColor: "white",
                  cursor: "pointer",
                  width: "48%",
                  textAlign: "left",
                  display: "inline-block",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                }}
              >
                {fileLabel} &nbsp;{fileName}
              </span>
            );
          })
          : "---",
      key: 6,
    },
  ];
  const actionTimeline = [
    {
      key: "1",
      name: incidentData?.name,
      action: "created the Incident",
      date: moment(incidentData?.date, "YYYY-MM-DD").format("Do MMMM YYYY"),
      time: moment(incidentData?.time, "HH:mm:ss").format("hh:mm A"),
    },
    // {
    //   key: "2",
    //   name: "Elsa Joseph",
    //   action: "Moved to Verbal Warning",
    //   date: "04th Mar 2024",
    //   time: "10.20 AM",
    // },
    // {
    //   key: "3",
    //   name: "Elsa Joseph",
    //   action: "Moved to First Warning",
    //   date: "04th Mar 2024",
    //   time: "10.20 AM",
    // },
    // {
    //   key: "4",
    //   name: "Elsa Joseph",
    //   action: "Commented",
    //   date: "04th Mar 2024",
    //   time: "10.20 AM",
    // },
    // {
    //   key: "5",
    //   name: "Elsa Joseph",
    //   action: "Moved to Second Warning",
    //   date: "04th Mar 2024",
    //   time: "10.20 AM",
    // },
    // {
    //   key: "6",
    //   name: "Elsa Joseph",
    //   action: "Moved to Third & Final Warning",
    //   date: "04th Mar 2024",
    //   time: "10.20 AM",
    // },
    // {
    //   key: "7",
    //   name: "Elsa Joseph",
    //   action: "Moved to Show Cause",
    //   date: "04th Mar 2024",
    //   time: "10.20 AM",
    // },
  ];

  const [comment, setComment] = useState("");
  const [record, setRecord] = useState({});
  const [selectedAction, setSelectedAction] = useState("");
  const filteruser = userList?.filter(
    (item) => item?.userid === get(userInfo, "userid", "")
  );

  const LOCATION_TIMEZONE_MAP = {
    "1": "Africa/Nairobi"
  };

  const userTimezone =
    LOCATION_TIMEZONE_MAP[filteruser?.[0]?.baselocationid] || "Africa/Nairobi";

  const [assetsData, setDisData] = useState([]);
  const getDisData = async () => {
    try {
      // setLoading(true);

      const { data, code } = await CALL_API(
        `incident/${incidentData.incidentId}`,
        "get",
        {}
      );

      if (code === "SUCCESS") {
        setDetails(data);
      } else {
        console.error("Invalid API Response:", data);
        message.error("Failed to fetch data. Please try again.");
      }
    } catch (error) {
      console.error("API Error:", error);
      message.error("Something went wrong while fetching data.");
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    getDisData();
  }, []);

  const actionMove = async (iscomment) => {
    setIsLoading(true);
    try {
      const { message } = await CALL_API(`incident`, "post", {
        incidentId: incidentData.incidentId,
        insertedby: userInfo?.name,
        comment: iscomment ? comment : "",
        actionmoveon: iscomment ? "Commented" : selectedAction,
        profileUrl: filteruser[0]?.profileurl,
      });

      if (message === "Incident Updated Successfully") {
        await getDisData();
        setComment("");
        if (iscomment) {
          setSelectedAction(""); // Reset selected action if it's a comment
        }
      } else {
        // message.error("update failed");
      }
    } catch (error) {
      // console.error("Error during API call:", error);
      // message.error("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    if (!selectedAction) return;
    actionMove(false);
  }, [selectedAction]);


  return (
    <>
      <Styleddiv>
        <div>
          <div className="breadcrumb">
            <p className="disciplinary-text" onClick={handleBack}>
              My Incident
            </p>
            &nbsp;
            <RightOutlined /> &nbsp;
            <p className="view-detail">View Detail</p>
          </div>
          <div className="name-edit-delete">
            <div className="emp-name-id">
              <p className="emp-name">{incidentData?.name}</p>{" "}
              <span className="line-emp-id">|</span>
              <span className="emp-id">{incidentData?.employeeId}</span>
            </div>
            <div className="trash-edit-move">
              {incidentData?.actionmoveon !== "Dismissed" &&
                incidentData?.actionmoveon !== "Resolved" &&
                incidentData?.actionmoveon !== "Under Review" &&
                !details?.actiontimeline?.some(
                  (item) =>
                    item.actionmoveon === "Dismissed" ||
                    item.actionmoveon === "Resolved" ||
                    item.actionmoveon === "Under Review"
                ) && (
                  <>
                    {Menulist?.find(
                      (item) =>
                        item?.key === "myincident" && item?.permission.delete
                    ) && (
                        <Trash
                          onClick={() => {
                            handleDeleteOpen(incidentData?.incidentId);
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      )}
                    {Menulist?.find(
                      (item) =>
                        item?.key === "myincident" && item?.permission.edit
                    ) && (
                        <Edit
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            const updatedRecord = {
                              ...incidentData,
                              time: incidentData.time
                                ? moment(incidentData.time, "HH:mm:ss")
                                : null,
                              updatedAt: incidentData.updatedAt
                                ? moment(incidentData.updatedAt)
                                : null,
                            };
                            handleEditDisciplinary(incidentData);
                            form.setFieldsValue(updatedRecord);
                            setIsModalOpen(true);
                          }}
                        />
                      )}
                  </>
                )}
            </div>
          </div>
          <br />
          <div className="two-container">
            <div className="employee-total">
              <div className="id-upload">
                <div className="employee-id">
                  <span className="employee-title">Incident ID: </span>
                  {incidentData?.incidentId}
                </div>
              </div>
              <br />
              <div>
                {EmployeeId.map((item) => (
                  <div
                    key={item.key}
                    className={
                      item.title === "Attachment"
                        ? "attachment-div"
                        : "employee-div"
                    }
                  >
                    <p className="employee-title">{item.title}</p>
                    <p
                      className="item-value"
                      style={
                        item.value === "Termination" ? { color: "#D90325" } : {}
                      }
                    >
                      {item.value}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className="timeline-total">
              <div className="actions-timeline">Actions Timeline</div>
              <br />
              <div className="scrollable-container">
                <div className="face-content1">
                  <div>
                    {!filteruser[0]?.profileurl ||
                      filteruser[0]?.profileurl.trim() === "" ? (
                      <StyledAvatar size="default">
                        {startCase(incidentData?.name?.charAt(0) || "N")}
                      </StyledAvatar>
                    ) : (
                      <StyledAvatar
                        src={filteruser[0]?.profileurl}
                        size="default"
                      ></StyledAvatar>
                    )}
                  </div>
                  <div className="timeline-item">
                    <span className="timeline-name">
                      {incidentData?.name};&nbsp;
                    </span>
                    <span className="timeline-date-time1">
                      created the incident
                    </span>
                    <br />
                    <span className="timeline-date-time">


                      {incidentData?.insertedAt
                        ? moment
                          .utc(incidentData?.insertedAt)
                          .tz(
                            userTimeZone
                          )
                          .format("Do MMM, YYYY; hh:mm A")
                        : "-"}

                    </span>
                  </div>
                </div>

                {details?.actiontimeline?.map((item, index) => (
                  <div className="face-content" key={index}>
                    <div>
                      {!item?.profileUrl || item?.profileUrl.trim() === "" ? (
                        <StyledAvatar size="default">
                          {startCase(item?.insertedby?.charAt(0) || "N")}
                        </StyledAvatar>
                      ) : (
                        <StyledAvatar
                          src={item?.profileUrl}
                          size="default"
                        ></StyledAvatar>
                      )}
                    </div>

                    <div className="timeline-item">
                      <span className="timeline-name">
                        {item?.insertedby};&nbsp;
                      </span>
                      {item.actionmoveon !== "Commented" && (
                        <span className="timeline-action">Moved to </span>
                      )}
                      <span
                        className={`timeline-action ${item.actionmoveon === "Resolved"
                          ? "resolved"
                          : item.actionmoveon === "Dismissed"
                            ? "dismissed"
                            : item.actionmoveon === "Under Review"
                              ? "under-review"
                              : ""
                          }`}
                      >
                        {item?.actionmoveon}
                      </span>
                      {item.actionmoveon === "Commented" && (
                        <>
                          {isCommentVisible === index ? (
                            <span
                              className="for-commented"
                              onClick={() => handleCommentVisibility("")}
                            >
                              Close Comment <UpOutlined />
                            </span>
                          ) : (
                            <span
                              className="for-commented"
                              onClick={() => handleCommentVisibility(index)}
                            >
                              View Comment <DownOutlined />
                            </span>
                          )}
                        </>
                      )}
                      <br />
                      <span className="timeline-date-time">
                        {moment
                          .utc(item.insertedAt)
                          .tz(userTimezone)
                          .format("Do MMM, YYYY; hh:mm A")}
                      </span>
                      <br />
                      <br />
                      {isCommentVisible === index &&
                        item.actionmoveon === "Commented" && (
                          <div>
                            <p className="comment-para">{item?.comment}</p>
                          </div>
                        )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <br />
          <div>
            <div className="add-comments">Add Comments</div>
            <br />
            <Input
              placeholder="Type here..."
              className="comments-input"
              suffix={
                <div style={{ position: "relative", display: "inline-block" }}>
                  {isLoading && (
                    <Spin
                      size="small"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 1,
                      }}
                    />
                  )}
                  <Send
                    onClick={() => {
                      if (comment.trim() && !isLoading) actionMove(true);
                    }}
                    style={{
                      cursor:
                        comment.trim() && !isLoading
                          ? "pointer"
                          : "not-allowed",
                      color: comment.trim() ? "black" : "gray",
                      opacity: isLoading ? 0.5 : 1, // Dim the Send icon when loading
                    }}
                  />
                </div>
              }
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && comment.trim() && !isLoading) {
                  actionMove(true);
                }
              }}
            />
          </div>
        </div>
        <StyledModal
          width={470}
          height={140}
          footer={false}
          closable={false}
          open={isDeleteOpen}
          onCancel={handleDeleteCancel}
          style={{ marginTop: "100px" }}
        >
          <p className="delete-modal-text">
            Are you sure you want to delete this incident?
          </p>
          <br />
          <div className="yes-no-button">
            <Button onClick={handleDeleteCancel} className="no-button">
              No
            </Button>
            <Button onClick={handleDeleteConfirm} className="yes-button">
              Yes
            </Button>
          </div>
        </StyledModal>
        <StyledModal
          width={190}
          height={70}
          open={isDeletedModalOpen}
          onCancel={() => setIsDeletedModalOpen(false)}
          footer={false}
          closable={false}
          style={{ marginTop: "130px" }}
        >
          <div className="success-modal">
            <Tick />
            <p className="sent-successfully">Deleted</p>
          </div>
        </StyledModal>
        <Modal
          title={
            decodeURIComponent(
              fileUrl?.split("?")[0]?.split("/").pop() || ""
            ).replace(/^\d+-/, "") || "Attachment Preview"
          }
          open={isModalOpen1}
          onCancel={handleCloseModal}
          footer={null}
          centered
          width={850}
        >
          {fileUrl &&
            decodeURIComponent(fileUrl?.split("?")[0]?.split("/").pop() || "")
              .replace(/^\d+-/, "")
              .toLowerCase()
              .endsWith(".pdf") ? (
            <iframe
              src={fileUrl}
              width="100%"
              height="500px"
              style={{ border: "none" }}
            />
          ) : (
            <img
              src={fileUrl}
              alt="Preview"
              style={{
                width: "100%",
                height: "500px",
                // maxHeight: "500px",
                // display: "block",
                objectFit: "contain",
              }}
            />
          )}
        </Modal>

        {isModalOpen && (
          <ReportIncident
            isModalVisible={isModalOpen}
            closeModal={closeReportModal}
            details={selectedRecord}
            selectedIncidentId={selectedIncidentId}
            page={page}
          />
        )}

      </Styleddiv>
    </>
  );
}
const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  userInfo: getUserInfo(state),
  ClientId: getClientid(state),
  userList: getUserList(state),
  menuList: getMenuList(state),
  locationList: getLocations(state),
  timeZone: getTimeZone(state),
  CountryTimezone: getCountryTimezoneList(state),
});
export default connect(mapStateToProps)(ViewIncident);
